export default __webpack_public_path__ + "static/media/salesskywalker.53c8a85d.png";